import { Component, Vue } from 'vue-property-decorator';

import template from './alert.vue';
import { AlertState } from '@/definitions';
import { Action } from '@/store';

@Component({
  mixins: [template],
})
export default class Alert extends Vue {

  get alert(): AlertState {
    return this.$Store.state.alert;
  }

  hide() {
    this.$Store.dispatch(Action.HIDE_ALERT);
  }
}